import { render, staticRenderFns } from "./BreadCrumb.vue?vue&type=template&id=0484d9ab&scoped=true"
import script from "./BreadCrumb.vue?vue&type=script&lang=ts"
export * from "./BreadCrumb.vue?vue&type=script&lang=ts"
import style0 from "./BreadCrumb.vue?vue&type=style&index=0&id=0484d9ab&prod&lang=sass"
import style1 from "./BreadCrumb.vue?vue&type=style&index=1&id=0484d9ab&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0484d9ab",
  null
  
)

export default component.exports